<template>
  <div class="container">
    <div class="header">{{getTitle()}}</div>

    <div class="input-container">

      <div class="label-line">
        <span class="left-text">查詢車牌費用</span>
        <span class="right-text">請輸入車牌號碼，以查詢繳費資訊</span>
        <span class="right-text">登入會員即可綁定車號、綁定信用卡優惠卡片</span>
      </div>

      <div class="input-label">
        <label>車牌號碼 </label>

        <span v-if="registered_lps.length"
              class="dropdown-trigger"
              @click.stop="toggleDropdown">
              選取已登記車號
        </span>

      </div>

      <div class="input-wrapper">

        <input
          type="text"
          v-model="carNumber"
          placeholder="輸入全碼車牌號碼"
          class="input-field"
          @input="handleCarNumberChange"
          @keyup.enter="proceed"
        />

        <div v-show="showDropdown" class="dropdown">
          <div
            class="dropdown-option"
            v-for="(lp, index) in registered_lps"
            :key="index"
            @click="selectLP(lp.lpid)">
            {{ lp.lpid }}
          </div>
        </div>

        <!-- 最近查詢 -->
        <div v-if="recentCars.length" class="recent-car-list">

          <div class="recent-title">
            最近查詢
          </div>

          <div class="recent-cars">

            <span
              v-for="(car,index) in recentCars"
              :key="index"
              class="recent-car"
              @click="selectRecent(car)"
            >
              {{car}}
            </span>

          </div>

        </div>

      </div>

      <div class="button-container">
        <button @click="cancel" class="cancel-button">
          取消
        </button>

        <button @click="proceed" class="proceed-button">
          查詢
        </button>
      </div>

    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

  data() {
    return {

      carNumber: '',
      showDropdown: false,
      recentCars: []

    };
  },

  computed: {
    ...mapGetters([
      'user',
      'registered_lps'
    ])
  },

  props: {
    parkingInfo: {
      type: Object,
      required: true
    }
  },

  methods: {

    proceed() {

      if(!this.carNumber) return;

      let cars = JSON.parse(
        localStorage.getItem("recentCars") || "[]"
      );

      cars = cars.filter(c => c !== this.carNumber);

      cars.unshift(this.carNumber);

      cars = cars.slice(0,3);

      localStorage.setItem(
        "recentCars",
        JSON.stringify(cars)
      );

      this.recentCars = cars;

      this.$emit('updateState', {
        key: 'carNumber',
        value: this.carNumber
      });

      this.$emit('query-parking-fee');

    },

    cancel() {

      this.carNumber = '';

      this.$emit('cancel-payment');

    },

    toggleDropdown() {

      this.showDropdown = !this.showDropdown;

    },

    selectLP(selected) {

      this.carNumber = selected;

      this.showDropdown = false;

      this.$emit('updateState', {
        key: 'carNumber',
        value: selected
      });

    },

    selectRecent(car){

      this.carNumber = car;

    },

    handleClickOutside(event) {

      if (!this.$el
          .querySelector('.input-container')
          .contains(event.target)) {

        this.showDropdown = false;

      }

    },

    handleCarNumberChange(event) {

      const filtered = event.target.value
        .replace(/[^0-9A-Za-z]/g, '')
        .toUpperCase();

      this.carNumber = filtered;

    },

    getTitle() {

      if (this.parkingInfo.title ) {

        return `停車費用查詢繳費 - ${this.parkingInfo.title}`;

      } else {

        return '停車費用查詢繳費';

      }

    }

  },

  mounted() {

    document.addEventListener(
      'click',
      this.handleClickOutside
    );

    const cars = JSON.parse(
      localStorage.getItem("recentCars") || "[]"
    );

    this.recentCars = cars;

    if(cars.length){

      this.carNumber = cars[0];

    }

  },

  beforeUnmount() {

    document.removeEventListener(
      'click',
      this.handleClickOutside
    );

  }

};

</script>

<style scoped>

.container {
  width: 100%;
  height: 1140px;
  margin-top: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  margin: 0px;
  text-align: center;
  font-size: 64px;
  font-weight: 700;
  margin-top: 80px;
  margin-bottom: 30px;
  color: var(--green04);
}

.input-container {
  width: 48%;
  min-width: 560px;
  background-color: white;
  padding: 48px;
  box-sizing: border-box;
}

.label-line {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-text {
  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 38.08px;
  text-align: left;
  color: var(--gray15);
}

.right-text {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: right;
  color: var(--gray13);
}

.input-label {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: var(--gray13);
  margin-top: 32px;
}

.input-field {
  width: 100%;
  height: 64px;
  margin-top: 8px;
  border: 1px solid var(--gray06);
  border-radius: 12px;
  padding: 10px 16px;
  box-sizing: border-box;
  font-family: Inter;
  font-size: 16px;
  color: var(--gray15);
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 24px;
}

.cancel-button {
  width: 100px;
  height: 58px;
  border-radius: 99px;
  background-color: white;
  color: var(--green03);
  border: none;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
}

.proceed-button {
  width: 100px;
  height: 58px;
  border-radius: 99px;
  background-color: var(--green03);
  color: white;
  border: none;
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
}

/* dropdown */

.input-wrapper {
  position: relative;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  z-index: 1000;
  max-height: 150px;
  overflow-y: auto;
}

.dropdown-option {
  padding: 8px;
  cursor: pointer;
}

.dropdown-option:hover {
  background-color: #f0f0f0;
}


/* 最近查詢 */

.recent-car-list{
  margin-top:10px;
}

.recent-title{
  font-size:14px;
  color:#888;
  margin-bottom:4px;
}

.recent-cars{
  display:flex;
  flex-wrap:wrap;
  gap:8px;
}

.recent-car{
  padding:4px 10px;
  border-radius:20px;
  border:1px solid #ddd;
  cursor:pointer;
  font-size:14px;
  background:#fafafa;
}

.recent-car:hover{
  background:#f0f0f0;
}


/* mobile */

@media (max-width: 560px) {

  .container {
    margin-top: 56px;
  }

  .header {
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 32px;
  }

  .input-container {
    width: 343px;
    border-radius: 20px;
    padding: 20px;
    min-width: unset;
  }

  .label-line {
    flex-direction: column;
    align-items: flex-start;
  }

  .left-text {
    font-size: 20px;
  }

  .right-text {
    font-size: 14px;
    margin-top: 4px;
  }

  .input-label {
    font-size: 14px;
    margin-top: 24px;
  }

  .input-field {
    height: 48px;
  }

  .cancel-button,
  .proceed-button {
    width: 80px;
    height: 48px;
    font-size: 14px;
  }

  .button-container {
    gap: 16px;
  }

}

</style>